export default __webpack_public_path__ + "static/media/logoTimeForThePlanet.ba107cf8.png";